import { pharmacyRouteRegistry } from "../product-revival/navigation";
import type { PagePolicy } from "./types";

/**
 * Code-owned customer page manifest. React components remain application-owned;
 * plans and tenant overrides remain database-owned.
 */
export const PAGE_POLICIES: readonly PagePolicy[] = pharmacyRouteRegistry.map(
  (route) => {
    const requiredModule = route.requiredModule ?? route.legacyModules[0];
    return {
      key: route.id,
      path: route.path,
      match: route.match,
      section: route.section,
      label: route.label,
      icon: route.icon,
      order: route.order,
      navigation: route.navigation,
      release: "ENABLED",
      ...(requiredModule ? { requiredModule } : {}),
      ...(route.requiredPermission
        ? { requiredPermission: route.requiredPermission }
        : {}),
      ...(route.requiredRole ? { requiredRole: route.requiredRole } : {}),
    };
  },
);

export function getPagePolicy(key: string): PagePolicy | undefined {
  return PAGE_POLICIES.find((policy) => policy.key === key);
}

export function validatePagePolicies(
  policies: readonly PagePolicy[] = PAGE_POLICIES,
): string[] {
  const errors: string[] = [];
  const keys = new Set<string>();
  const routeMatches = new Set<string>();
  for (const policy of policies) {
    if (keys.has(policy.key)) {
      errors.push(`Duplicate page policy key: ${policy.key}`);
    }
    keys.add(policy.key);

    const routeMatch = `${policy.match}:${policy.path}`;
    if (routeMatches.has(routeMatch)) {
      errors.push(`Duplicate page policy route: ${routeMatch}`);
    }
    routeMatches.add(routeMatch);

    if (policy.navigation && !policy.requiredModule) {
      errors.push(`Navigation policy ${policy.key} has no required module`);
    }
  }
  return errors;
}
